import { RouterLinks } from '../app-route-paths';

export enum Users {
  ADMIN = 'Admin',
  USER = 'User',
}

export enum UserRoles {
  FINANCIAL_ADVISOR = 'financial_advisor',
  PARA_PLANNER = 'para_planner',
  ADMINISTRATOR = 'administrator',
  EXECUTIVE_OFFICER = 'executive_officer',
  COMPLIANCE_OFFICER = 'compliance_officer',
  RELATIONSHIP_MANAGER = 'relationship_manager',
  SUPER_ADMINISTRATOR = 'super_administrator',
}

export enum UserPathAccessRoles {
  ADMIN = 'Admin',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPER_ADMIN_FINANCIAL_ADVISOR = 'SUPER_ADMIN_FINANCIAL_ADVISOR',
  SUPER_ADMIN_ADVISOR_PROFILE_INCOMPLETE = 'SUPER_ADMIN_ADVISOR_PROFILE_INCOMPLETE',
  FINANCIAL_ADVISOR_PROFILE_INCOMPLETE = 'FINANCIAL_ADVISOR_PROFILE_INCOMPLETE',
  FINANCIAL_ADVISOR = 'FINANCIAL_ADVISOR',
  DEFAULT_USER_PROFILE_INCOMPLETE = 'DEFAULT_USER_PROFILE_INCOMPLETE',
  DEFAULT = 'DEFAULT',
  PARA_PLANNER = 'PARA_PLANNER',
}

const firmPaths = [
  RouterLinks.organisationProfile,
  RouterLinks.userManagement,
  RouterLinks.modelPortfolios,
  RouterLinks.riskAssessment,
  RouterLinks.financialPlanning,
  RouterLinks.adviceTemplates,
  RouterLinks.factFindConfiguration,
  RouterLinks.crm,
];

const profilePaths = [RouterLinks.certificationsAndExpertise, RouterLinks.meetingConfiguration];
const allProfilePaths = [RouterLinks.myProfile, RouterLinks.certificationsAndExpertise, RouterLinks.meetingConfiguration, RouterLinks.changePassword];

export const UserRolePaths = {
  [UserPathAccessRoles.SUPER_ADMIN]: { deniedPaths: [RouterLinks.dashboard, ...profilePaths] },
  [UserPathAccessRoles.SUPER_ADMIN_ADVISOR_PROFILE_INCOMPLETE]: { deniedPaths: [RouterLinks.dashboard] },
  [UserPathAccessRoles.SUPER_ADMIN_FINANCIAL_ADVISOR]: { deniedPaths: [] },
  [UserPathAccessRoles.FINANCIAL_ADVISOR_PROFILE_INCOMPLETE]: { deniedPaths: [...firmPaths, ...allProfilePaths, RouterLinks.dashboard] },
  [UserPathAccessRoles.FINANCIAL_ADVISOR]: { deniedPaths: [...firmPaths] },
  [UserPathAccessRoles.DEFAULT_USER_PROFILE_INCOMPLETE]: { deniedPaths: [RouterLinks.dashboard, ...firmPaths, ...allProfilePaths] },
  [UserPathAccessRoles.DEFAULT]: { deniedPaths: [RouterLinks.dashboard, ...firmPaths, ...profilePaths] },
};
